<template>
  <div id="receipt-show" style="margin-bottom: 55px">
    <b-card class="mb-5">
      <b-row>
        <b-col md="6">
          <!-- get name from router name -->
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/sales/delivery-order"
                >Delivery Order</router-link
              ></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>

        <b-col md="6" class="text-right mt-3">
          <!-- button export to pdf -->
          <b-button
            v-if="model.status === 'Done' || model.status === 'Received'"
            v-b-tooltip.hover.top
            title="Export to PDF"
            variant="info"
            @click="doExportPdf()"
            class="btn-download float-right"
            ><font-awesome-icon icon="download"
          /></b-button>
          <b-button
            v-if="model.status === 'Canceled'"
            variant="warning"
            class="mr-4"
            @click="doChangeStatusReceipt()"
            >Re-Create</b-button
          >
        </b-col>
      </b-row>
      <div class="border-bottom mb-3"></div>

      <div v-if="isLoading" style="z-index: 1000;">
        <div class="text-center" style="margin: 3% auto;">
          <b-spinner small type="grow" label="Small Spinner"></b-spinner>
          <b-spinner small variant="primary" type="grow" label="Small Spinner"></b-spinner>
          <b-spinner small variant="success" type="grow" label="Small Spinner"></b-spinner>
        </div>
      </div>

      <div v-else>
        <b-row>
          <b-col md="6">
            <b-row>
              <b-col md="4">
                <label class="labels">Number</label>
              </b-col>
              <b-col md="8">
                <p>{{ model.number !== null ? model.number : '-' }}</p>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4">
                <label class="labels">Customer</label>
              </b-col>
              <b-col md="8">
                <p>{{ model.customer !== null ? model.customer.name : '-' }}</p>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4">
                <label class="labels">Note</label>
              </b-col>
              <b-col md="8">
                <p>{{ model.note !== null ? model.note || '-' : '-' }}</p>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <label class="labels">Address</label>
              </b-col>
              <b-col md="8">
                <p>{{ model.customer !== null ? model.customer.address || '-' : '-' }}</p>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <label class="labels">Phone</label>
              </b-col>
              <b-col md="8">
                <p>{{ model.customer !== null ? model.customer.phone || '-' : '-' }}</p>
              </b-col>
            </b-row>

            <b-row> </b-row>
            <b-row> </b-row>
          </b-col>

          <b-col>
            <b-row>
              <b-col md="4">
                <label class="labels">Received</label>
              </b-col>
              <b-col md="8">
                <p>{{ model.receivedBy !== null ? model.receivedBy : '-' }}</p>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <label class="labels">Status</label>
              </b-col>
              <b-col md="8">
                <p>
                  <b-badge :variant="getStatusColor(model.status)">{{
                    model.status !== null ? model.status : '-'
                  }}</b-badge>
                </p>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4">
                <label class="labels">Created By</label>
              </b-col>
              <b-col md="8">
                <p>{{ model.createdBy !== null ? model.createdBy : '-' }}</p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row v-if="model.status !== 'Created' && model.status !== 'Canceled'">
          <b-col md="6" v-if="model.evidences.length > 0">
            <h3 class="mb-3 mt-4">Photo</h3>
            <viewer v-for="(image, i) in model.evidences" :key="i" class="mx-2 mt-2">
              <b-row>
                <b-col md="3">
                  <b-img
                    :src="image"
                    v-b-tooltip.focus
                    class="img-responsive border-radius"
                    width="200"
                    height="200"
                  />
                </b-col>
              </b-row>
            </viewer>
          </b-col>

          <b-col md="6" v-if="model.receivedEvidences.length > 0">
            <h3 class="mb-3 mt-4">Received Photo</h3>
            <div class="d-flex">
            <viewer v-for="(image, i) in model.receivedEvidences" :key="i" class="mx-2 mt-2">
              <b-row>
                <b-col md="3">
                  <b-img
                    :src="image"
                    v-b-tooltip.focus
                    class="img-responsive border-radius"
                    width="200"
                    height="200"
                  />
                </b-col>
              </b-row>
            </viewer>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col md="12">
            <h3 class="mb-3 mt-4">History Status</h3>
            <div class="table-responsive">
              <table class="table table-hovered table-striped">
                <thead>
                  <tr>
                    <!-- <th scope="col" width="250">Date</th> -->
                    <th scope="col" width="100" class="labels">Status</th>
                    <th scope="col" width="250" class="labels">Created By</th>
                    <th scope="col" width="250" class="labels" v-if="model.status === 'Shipping'">
                      Shipping By
                    </th>
                    <th scope="col" width="250" class="labels" v-else>Shipped By</th>
                    <th scope="col" width="250" class="labels">Received By</th>
                    <th scope="col" width="250" class="labels">Canceled By</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <!-- <td v-text="getDateTime(model.createdAt)"></td> -->
                    <td>
                      <p>
                        <b-badge :variant="getStatusColor(model.status)">{{
                          model.status !== null ? model.status : '-'
                        }}</b-badge>
                      </p>
                    </td>
                    <td>
                      <p>{{ model.createdBy !== null ? model.createdBy : '-' }}</p>
                      <p class="font-weight-light">
                        {{ new Date(model.createdAt).toLocaleString() }}
                      </p>
                    </td>
                    <td>
                      <div v-if="model.status === 'Shipping'">
                        <p>
                          {{ model.shippedBy + ' ' }}
                          <i class="fa fa-truck text-info" aria-hidden="true"></i>
                        </p>
                        <p>{{ new Date(model.shippedAt).toLocaleString() }}</p>
                        <p></p>
                      </div>
                      <div v-else>
                        <p v-if="showShipped">{{ model.shippedBy }}</p>
                        <p v-if="showShipped">{{ new Date(model.shippedAt).toLocaleString() }}</p>
                        <p v-else class="text-info font-weight-bold">-</p>
                      </div>
                    </td>
                    <td>
                      <p v-if="showReceive">{{ model.receivedBy }}</p>
                      <p v-if="showReceive">{{ new Date(model.receivedAt).toLocaleString() }}</p>
                      <p v-else class="text-info font-weight-bold">-</p>
                    </td>
                    <td>
                      <p v-if="showCancel">{{ model.canceledBy }}</p>
                      <p v-if="showCancel" v-text="new Date(model.canceledAt).toLocaleString()"></p>
                      <p v-else class="text-info font-weight-bold">-</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col>
            <h3 class="mb-3 mt-4">Item</h3>
          </b-col>

          <!-- table item -->
          <b-col md="12">
            <div class="table-responsive">
              <table class="table small-text table-striped">
                <thead>
                  <tr>
                    <th scope="col" width="100">Item Name</th>
                    <th scope="col" class="text-center" width="100">Quantity</th>
                    <th scope="col" class="text-center" width="100">Unit</th>
                    <th scope="col" class="text-center" width="100">Quantity Received</th>
                    <th scope="col" class="text-center" width="100">Note</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in model.items" :key="i">
                    <td
                      style="white-space: pre-line"
                      v-text="item.itemList ? item.itemList.name : '-'"
                    ></td>
                    <td class="text-center" v-text="item.quantity"></td>
                    <td class="text-center" v-text="item.itemList.unit ? item.itemList.unit : '-'"></td>
                    <td class="text-center" v-text="item.quantityReceived"></td>
                    <td class="text-center" style="white-space: pre-wrap;" v-text="item.note"></td>
                    <!-- <td v-text="item.quantity * item.price"></td> -->
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
          <!-- end table item -->
        </b-row>
        <b-row class="mt-3 mb-2" v-if="model.returnedItems.length > 0">
          <b-col md="12">
            <h3>Returned Item</h3>
            <table class="table table-hovered table-striped">
              <thead>
                <tr>
                  <th scope="col" width="250">Item Name</th>
                  <th scope="col" width="100" class="text-center">Quantity Returned</th>
                  <th scope="col" width="100" class="text-center">Unit</th>
                  <th scope="col" width="100" class="text-center">Status</th>
                  <th scope="col" width="200">Note</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(returned, i) in model.returnedItems" :key="i">
                  <td style="white-space: pre-line;">
                    {{ returned.itemList !== null ? returned.itemList.name : '' }}
                  </td>
                  <td class="text-center">
                    {{ returned.quantity !== null ? returned.quantity : 0 }}
                  </td>
                  <td class="text-center">
                    {{ returned.itemList !== null ? returned.itemList.unit : '' }}
                  </td>
                  <td class="text-center">
                    <b-badge :variant="getStatusColor(returned.status)">{{
                      returned.status !== null ? returned.status : ''
                    }}</b-badge>
                  </td>
                  <td>{{ returned.note !== '' && returned !== null ? returned.note : '-' }}</td>
                </tr>
              </tbody>
            </table>
          </b-col>
          <div class="mb-5" v-if="model.returnedItems[0].status === 'Requested'">
            <form>
              <b-button
                variant="success"
                @click="showModalApproved()"
                class="bordered-card ml-3 mt-3 mb-4"
              >
                <i class="fas fa-check-circle"></i>
                Approve</b-button
              >
            </form>
          </div>
        </b-row>
        <b-modal id="bv-modal-approved" size="md" centered hide-footer title="Approved Items">
          <form v-on:submit.prevent="sendApproved">
            <label class="labels">note</label>
            <b-form-textarea
              id="textarea-auto-height"
              rows="3"
              max-rows="8"
              v-model="approved.note"
              placeholder="Note"
            >
            </b-form-textarea>
          </form>
          <button
            class="mt-3 btn btn-outline-danger"
            size="md"
            @click="$bvModal.hide('bv-modal-approved')"
          >
            <font-awesome-icon icon="times"></font-awesome-icon> Cancel
          </button>
          <b-button
            :disabled="!disable"
            class="float-right mt-3"
            variant="success"
            @click="sendApproved"
          >
            <font-awesome-icon icon="save"></font-awesome-icon>
            {{ isLoadingButton ? 'please wait..' : 'Save' }}
          </b-button>
        </b-modal>
      </div>

      <!-- button back -->
      <b-button class="mt-5" @click="goBack()" variant="secondary"
        ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
      >
      <b-button
        v-if="(model.status === 'Created') | (model.status === 'CREATED')"
        class="mt-5 float-right"
        :to="'/sales/delivery-order/' + $route.params.uuid + '/edit'"
        variant="warning"
        ><font-awesome-icon icon="pencil-alt"></font-awesome-icon> Edit</b-button
      >
    </b-card>
  </div>
</template>

<script>
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import Vue from 'vue';
Vue.use(Viewer);

export default {
  name: 'receipt-show',

  data() {
    return {
      isLoadingButton: false,
      isLoading: false,
      dataAccount: this.$store.getters['account/accountData'],
      apiUrl: {
        receipt: window.AppConfig.apiUrl + 'receipt',
        items: window.AppConfig.apiUrl + 'item',
        exportReceipt: window.AppConfig.apiUrl + 'export-receipt-pdf',
        returnedItem: window.AppConfig.apiUrl + 'request-returns-items',
      },
      type: null,
      formData: {
        status: 'Created',
        createdAt: null,
        note: null,
      },

      mainProps: {
        center: true,
        fluidGrow: true,
        blank: true,
        blankColor: '#bbb',
        width: 200,
        height: 200,
        class: 'my-3',
      },

      model: {
        number: '',
        note: null,
        receivedBy: '',
        status: '',
        createdAt: '',
        updatedAt: '',
        createdBy: '',
        receivedAt: '',
        shippedBy: '',
        shippedAt: '',
        statusValue: '',
        statusText: '',
        statusTime: '',
        customer: null,
        statusTextTime: '',
        returnedItems: [],
        evidences: [],
        receivedEvidences: [],
        items: {},
      },
      approved: {
        note: '',
        status: 'Approved',
        receipt: '',
      },
      showReceive: true,
      showShipped: true,
      showCancel: true,
    };
  },

  computed: {
    disable() {
      if (this.approved.note.length > 1) {
        return true;
      }
      return false;
    },
  },

  mounted() {
    this.getDetailReceiptItem();
    this.getDateTime();
  },

  methods: {
    getDetailReceiptItem() {
      this.isLoading = true;
      this.$http
        .get(this.apiUrl.receipt + '/' + this.$route.params.uuid)
        .then((response) => {
          this.model.number = response.data.number !== null ? response.data.number : '-';
          this.model.customer = response.data.customer !== null ? response.data.customer : '-';
          this.model.note = response.data.note !== null ? response.data.note : '-';
          this.model.items = response.data.items !== null ? response.data.items : '-';
          this.model.receivedBy =
            response.data.receivedBy !== null ? response.data.receivedBy : '-';
          this.model.status = response.data.status !== null ? response.data.status : '-';
          this.model.createdAt = response.data.createdAt !== null ? response.data.createdAt : '-';
          this.model.updatedAt = response.data.updatedAt !== null ? response.data.updatedAt : '-';
          this.model.createdAt = response.data.createdAt !== null ? response.data.createdAt : '-';
          this.model.receivedAt =
            response.data.receivedAt !== null ? response.data.receivedAt : '-';
          this.model.shippedBy = response.data.shippedBy !== null ? response.data.shippedBy : '-';
          this.model.shippedAt = response.data.shippedAt !== null ? response.data.shippedAt : '-';
          this.model.createdBy = response.data.createdBy !== null ? response.data.createdBy : '-';
          this.model.canceledBy =
            response.data.canceledBy !== null ? response.data.canceledBy : '-';
          this.model.canceledAt =
            response.data.canceledAt !== null ? response.data.canceledAt : '-';
          this.model.updatedAt = response.data.updatedAt !== null ? response.data.updatedAt : '-';
          this.model.status = response.data.status !== null ? response.data.status : '-';
          this.model.evidences = response.data.evidences !== null ? response.data.evidences : '-';
          if (response.data.receivedBy === null) {
            this.showReceive = false;
          }
          if (response.data.shippedBy === null) {
            this.showShipped = false;
          }
          if (response.data.canceledBy === null) {
            this.showCancel = false;
          }
          if (response.data.returnedItems) {
            response.data.returnedItems.forEach((data) => {
              this.model.returnedItems.push(data);
            });

          if (response.data.evidences){
            this.model.evidences = response.data.evidences
          }

          if(response.data.receivedEvidences){
            this.model.receivedEvidences = response.data.receivedEvidences
            }
          
            // console.log('data return is:', this.model.returnedItems);
          }
          setTimeout(() => {
            this.isLoading = false;
          }, 800);
        })
        .catch(() => {
          // this.isLoading = false
        });
    },

    doExportPdf() {
      let url = this.apiUrl.exportReceipt + '?receipt_uuid=' + this.$route.params.uuid;

      window.open(url);
    },

    showModalApproved() {
      (this.approved.note = null),
        (this.approved.status = 'Approved'),
        (this.approved.receipt = this.$route.params.uuid);
      this.$bvModal.show('bv-modal-approved');
    },

    sendApproved() {
      this.isLoadingButton = true;
      this.$http
        .post(this.apiUrl.returnedItem, this.approved)
        .then(() => {
          this.$store.dispatch('notification/success', 'Aprroved Successfuly');
          this.$bvModal.hide('bv-modal-approved');
          this.isLoadingButton = false;
          location.reload();
          this.getDetailReceiptItem();
        })
        .catch((error) => {
          this.isLoadingButton = false;
          this.$store.dispatch('notification/error', error);
        });
      console.log('approved send:', this.approved);
    },

    doChangeStatusReceipt() {
      this.isLoading = true;
      this.$http
        .post(window.AppConfig.apiUrl + 'receipt-status', {
          receipt: this.$route.params.uuid,
          status: this.formData.status,
        })
        .then(() => {
          this.isLoading = false;
          this.formData.status = null;
          this.getDetailReceiptItem();
          // this.$bvModal.hide('bv-modal-receipt')
          this.$store.dispatch('notification/success', 'Delivery Order status has been changed');
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notification/error', error);
        });
    },

    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('LLL');
      } else {
        return '-';
      }
    },

    getStatusColor(val) {
      switch (val) {
        case 'Created':
          return 'warning';
          // eslint-disable-next-line no-unreachable
          break;

        case 'Requested':
          return 'warning';
          // eslint-disable-next-line no-unreachable
          break;

        case 'Shipping':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;

        case 'Shipped':
          return 'success';
          // eslint-disable-next-line no-unreachable
          break;

        case 'Approved':
          return 'success';

        case 'Received':
          return 'primary';
          // eslint-disable-next-line no-unreachable
          break;

        case 'Canceled':
          return 'secondary';
          // eslint-disable-next-line no-unreachable
          break;

        case 'Returning':
          return 'info';

        case 'Done':
          return 'primary';
      }
    },

    doFilter() {
      this.tableFilter.receipt_start_date =
        this.tableFilter.date !== null
          ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD')
          : null;
      this.tableFilter.receipt_end_date =
        this.tableFilter.date !== null
          ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD')
          : null;
      this.$refs.dataTable.doFilter(this.tableFilter);
    },

    goBack() {
      window.goBack(this);
    },
  },
};
</script>
